<template>
  <div class="VueTables__search-field w-100  mr-3">
    <div class="row">
      <div class="col-md-3">

        <div class="form-group">
          <label :for="`VueTables__search_${props.id}`" :class="props.theme.label">
            {{ props.display("filter") }}
          </label>

          <input :class="`VueTables__search__input ${props.theme.input} ${props.theme.small}`"
              type="text"
              :placeholder="props.display('filterPlaceholder')"
              @keyup="e=>props.search(props.debounce)(e)"
              :id="`VueTables__search_${props.id}`"
              autocomplete="off"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>{{lexicon.drop_period}}</label>
          <date-range-picker v-model="period" format="YYYY-MM-DD" :options="options"
              class="form-control"/>
        </div>
      </div>
      <div class="col-md-3" id="changeTypeSelect">
        <div class="form-group">
          <label>{{lexicon.drop_op_type}}</label>
          <select class="form-control" @change="changeType" v-model="operation">
            <option value="" selected> {{lexicon.drop_all}}</option>
            <option value="0">{{lexicon.drop_bal_minus}}</option>
            <option value="1">{{lexicon.drop_bal_plus}}</option>

          </select>
        </div>
      </div>
      <div class="col-md-3" id="changeStatusSelect">
        <div class="form-group">
          <label>{{lexicon.drop_status_select}}</label>
          <select class="form-control" @change="changeStatus" v-model="status_code">
            <option value="" selected> {{lexicon.drop_all}}</option>
            <option value="new">{{lexicon.drop_new_status_new}}</option>
            <option value="processing">{{lexicon.drop_new_status_processing}}</option>
            <option value="packing">{{lexicon.drop_new_status_packing}}</option>
            <option value="packed">{{lexicon.drop_new_status_packed}}</option>
            <option value="sent">{{lexicon.drop_new_status_sent}}</option>
            <option value="cancelled">{{lexicon.drop_new_status_cancelled}}</option>
            <option value="completed">{{lexicon.drop_new_status_completed}}</option>
<!--            <option value="1">{{lexicon.drop_status_new}}</option>-->
<!--            <option value="2">{{lexicon.drop_status_in_progress}}</option>-->
<!--            <option value="3">{{lexicon.drop_status_sent}}</option>-->
<!--            <option value="4">{{lexicon.drop_status_fail}}</option>-->
          </select>
        </div>
      </div>
      <div class="col-md-3" id="changeNPStatusSelect">
        <div class="form-group">
          <label>{{lexicon.drop_delivery_status}}</label>
          <select class="form-control" @change="changeNPStatus" v-model="np_status">
            <option value="" selected>{{lexicon.drop_all}}</option>
            <option value="1">{{lexicon.drop_status_preprare}}</option>
            <option value="2">{{lexicon.drop_status_sent}}</option>
            <option value="3">{{lexicon.drop_status_delivered}}</option>
            <option value="4">{{lexicon.drop_status_arriveed}}</option>
            <option value="5">{{lexicon.drop_status_canceled}}</option>
            <option value="0">{{lexicon.drop_status_another}}</option>
          </select>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapState} from 'vuex'
import {Event} from 'vue-tables-2';

export default {
  name: "FilterForm",
  props: ['props'],
  data() {
    return {
      status: '',
      status_code: '',
      operation: '',
      np_status: '',
      period: [],
      options: {
        // startDate: window.moment().add(-1, 'month'),
        // endDate: window.moment(),
        minYear: 2018,
        maxYear: +window.moment().format("YYYY"),
        locale: {
          format: 'YYYY-MM-DD'
        },
        autoApply: true,
        showDropdowns: true,
      }
    }
  },

  watch: {
    period: function () {
      this.changeDate()
    }
  },

  computed: mapState({
    lexicon: state => state.lexicon
  }),
  created() {
    Event.$on('change-period', this.changePeriod)
    Event.$emit('wait-period');
  },
  methods: {
    changeType() {
      Event.$emit('vue-tables.filter::operation', this.operation);
    },
    changeStatus() {
      Event.$emit('vue-tables.filter::status_code', this.status_code);
    },
    changeNPStatus() {
      Event.$emit('vue-tables.filter::np_status', this.np_status);
    },
    changeDate() {
      if (this.period[0] && this.period[1]) {
        let data = {
          'start': window.moment(this.period[0] + " 00:00:00"),
          'end': window.moment(this.period[1] + " 23:59:59")
        }
        Event.$emit('vue-tables.filter::period', data);
      }
    },
    changePeriod(data) {
      this.period = data
      this.options.startDate = window.moment(data[0])
      this.options.endDate = window.moment(data[1])
    }
  }
}
</script>